export const FETCH_COMPACTING_REPORTS_DATA_REQUEST = 'FETCH_COMPACTING_REPORTS_DATA_REQUEST';
export const FETCH_COMPACTING_REPORTS_DATA_SUCCESS = 'FETCH_COMPACTING_REPORTS_DATA_SUCCESS';
export const FETCH_COMPACTING_REPORTS_DATA_FAILURE = 'FETCH_COMPACTING_REPORTS_DATA_FAILURE';

export const CREATE_USER_FORM_COMPACTING_REPORT = 'CREATE_USER_FORM_COMPACTING_REPORT';

export const SET_SUMMARY_GRID_NAME_COMPACTING_REPORT_DK = 'SET_SUMMARY_GRID_NAME_COMPACTING_REPORT_DK';